import { MODAL_API_KEY_CREATED } from '@components/App/Modal/constants'
import { LoaderActions } from '@store/loaders'
import { ErrorNotification } from '@storeOld/reducers/notification'
import { openModal } from '@storeOld/reducers/ui'
import { call, put } from 'redux-saga/effects'

import { GtmTriggerName, sendGtmEvent } from '@/constants/gtm'
import { ApiKeysService, type IssuedApiKey } from '@/services/apiKeys'
import { ApiKeysActions } from '../actions'

export function* createApiKey({
  payload,
}: ReturnType<typeof ApiKeysActions.create>) {
  const event = payload.scopes.includes('write')
    ? GtmTriggerName.API_KEY_CREATE_WRITE
    : GtmTriggerName.API_KEY_CREATE_READ

  sendGtmEvent(event)

  yield put(LoaderActions.set('api_keys_create'))

  try {
    const issued: IssuedApiKey = yield call(ApiKeysService.create, payload)

    yield put(
      openModal({
        modalType: MODAL_API_KEY_CREATED,
        modalProps: { issued },
      })
    )

    yield put(ApiKeysActions.fetch())
  } catch (error) {
    console.error('Failed to create API key', error)

    yield put(ErrorNotification('Failed to create API key'))
  } finally {
    yield put(LoaderActions.unset('api_keys_create'))
  }
}
